module.exports = __webpack_public_path__ + "images/all-skus-blue-05b430da.svg";